import styled from 'styled-components';
import { Checkbox } from 'antd';
import { media } from 'utils/styledHelpers';

interface StyledColoredGGRProps {
  $isNegative: boolean;
}

const StyledPaymentCheckbox = styled(Checkbox)`
  border-right: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  padding-right: 1.14rem;
  padding-left: 1.14rem;
  margin-bottom: 0.57rem;
  ${media.sm`
    padding-right: 0rem;
    border-right: none;
  `}
`;

const StyledConfigRadioButton = styled.div`
  border-right: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  display: flex;
  margin: 0 0 0.57rem 1.14rem;
  .ant-radio-wrapper {
    margin-right: 1.14rem;
    font-size: 1rem;
    color: ${(props) => props.theme.colors.primaryText};
  }
  &:last-child {
    border: none;
    .ant-radio-group > div:last-child {
      margin-right: 0;
    }
  }

  ${media.sm`
    border: none;
    
    .ant-radio-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 1.14rem;
      
      .ant-radio-wrapper {
        margin-right: 0;
      }
    }
  `}
`;

const StyledConfigWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 2.28rem;
  .ant-radio-wrapper {
    margin: 3px 0 0 0;
  }

  ${media.sm`
    margin-right: 0;
  `}
`;

const StyledColoredGGR = styled.div<StyledColoredGGRProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  color: ${(props) => (props.$isNegative ? props.theme.colors.danger : props.theme.colors.success)};
  background-color: ${(props) => (props.$isNegative ? props.theme.colors.danger : props.theme.colors.success)}20;
  border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
  font-size: 1rem;
  line-height: 1rem;
  padding: 0.57rem 0.71rem;

  div {
    svg {
      transform: ${(props) => (props.$isNegative ? 'rotate(180deg)' : 'none')};
      margin-top: -2px;
      g path {
        fill: ${(props) => (props.$isNegative ? props.theme.colors.danger : props.theme.colors.success)};
      }
    }
  }
`;

export {
  StyledConfigRadioButton, StyledPaymentCheckbox, StyledConfigWrapper, StyledColoredGGR,
};
